import { useProducts } from 'api/productApi';
import { StyledSelect } from 'styles/overrides';
import _ from 'lodash';
import { filterOptions } from 'utils/formatUtils';
import { useCustomSearchParams } from 'hooks/useCustomSearchParams';

export default function ProductSelector({
  onChange,
  value,
  params = {},
  ...restProps
}) {
  const [search] = useCustomSearchParams();
  const { data = [], isLoading } = useProducts({
    params: {
      page_size: 1000,
      // locale_code: params _.get(search, ['locale_code']),
      ...params,
    },
    options: {
      select: (response) =>
        _.map(response?.data, ({ id, name }) => ({
          label: name,
          value: id.toString(),
        })) ?? [],
    },
  });

  return (
    <StyledSelect
      options={data}
      loading={isLoading}
      showSearch
      optionFilterProp="label"
      filterOption={filterOptions}
      {...restProps}
      onChange={onChange}
      value={value}
    />
  );
}
